import { render, staticRenderFns } from "./classlist.vue?vue&type=template&id=81dc134a&scoped=true"
import script from "./classlist.vue?vue&type=script&lang=js"
export * from "./classlist.vue?vue&type=script&lang=js"
import style0 from "./classlist.vue?vue&type=style&index=0&id=81dc134a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81dc134a",
  null
  
)

export default component.exports